module.exports = __webpack_public_path__ + "static/media/f2.f7ee89af.png";